import { faCircleExclamation, faDownload, faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popper } from "@mui/material";
import TooltipMUI from '@mui/material/Tooltip';
import { css, styled } from '@mui/system';
import { process } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { setExpandedState, setGroupIds } from '@progress/kendo-react-data-tools';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridColumn as Column, Grid, GridColumnMenuFilter, GridColumnMenuGroup, GridColumnMenuSort, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import History from '../../@history';
import LoaderOverlay from '../../components/custom-loader/LoaderOverlay';
import { applyFilter, applySort, flatternGroup } from '../../custom/commonExport';
import Images from '../../custom/flagExport';
import { validateUserData } from '../../custom/UserExport';
import { exportData, getDashboardData, getDashboardDataByPagination } from '../../services/dashboard-service/dashboardService';



const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};


const mappingFields = {
    "vehicleid": {
        "value": "Vehicle ID",
        "width": "200px"
    },
    "vehiclecount": {
        "value": "Vehicle Count",
        "width": "200px"
    },
    "regplate": {
        "value": "Regplate",
        "width": "200px"
    },
    "manufacturerid": {
        "value": "Manufacturer ID",
        "width": "200px"
    },
    "manufacturer": {
        "value": "Manufacturer",
        "width": "200px"
    },
    "modelid": {
        "value": "Model ID",
        "width": "200px"
    },
    "model": {
        "value": "Model Name",
        "width": "200px"
    },
    "variant": {
        "value": "Variant",
        "width": "200px"
    },
    "enginecode": {
        "value": "Engine Code",
        "width": "200px"
    },
    "from": {
        "value": "From Date",
        "width": "200px"
    },
    "to": {
        "value": "To Date",
        "width": "200px"
    },
    "abenr": {
        "value": "ABENr",
        "width": "200px"
    },
    "power_ps": {
        "value": "Power (PS)",
        "width": "200px"
    },
    "power_kw": {
        "value": "Power (kW)",
        "width": "200px"
    },
    "capacity_technical": {
        "value": "Technical Capacity",
        "width": "250px"
    },
    "capacity": {
        "value": "Capacity",
        "width": "200px"
    },
    "numberofvalves": {
        "value": "Number of Valves",
        "width": "200px"
    },
    "numberofcylinders": {
        "value": "Number of Cylinders",
        "width": "200px"
    },
    "bodytype": {
        "value": "Body Type",
        "width": "200px"
    },
    "drivetype": {
        "value": "Drive Type",
        "width": "200px"
    },
    "fueltype": {
        "value": "Fuel Type",
        "width": "200px"
    },
    "fuelmixture": {
        "value": "Fuel Mixture",
        "width": "200px"
    },
    "kbanumber": {
        "value": "KBA Number",
        "width": "200px"
    },
}

const regions = [
    { id: 1, name: 'Finland', value: "fi", flag: Images["fi"] },
    { id: 2, name: 'Sweden', value: "se", flag: Images["se"] },
    { id: 3, name: 'Denmark', value: "dk", flag: Images["dk"] },
    { id: 4, name: 'Estonia', value: "et", flag: Images["et"] },
    { id: 5, name: 'France', value: 'fr', flag: Images["fr"] },
    { id: 6, name: 'Italy', value: 'it', flag: Images["it"] },
    { id: 7, name: 'Norway', value: 'no', flag: Images["no"] },
    { id: 8, name: 'Spain', value: 'sp', flag: Images["sp"] },
    { id: 9, name: 'UK', value: 'uk', flag: Images["uk"] },
];

const DATA_ITEM_KEY = 'vehicleid';
const initialDataState = {
    take: 100,
    skip: 0,
    sort: [],
    group: [],
    filter: { logic: "and", filters: [] }
};

const processWithGroups = (data, dataState) => {
    const newDataStateChanges = {
        ...dataState,
        filter: { filters: [], logic: "and" },
        skip: 0
    }
    const newDataState = process(data, newDataStateChanges);
    setGroupIds({
        data: newDataState.data,
        group: dataState.group
    });
    return newDataState
};

function HomePage() {
    const location = useLocation()
    const { newMonth } = location.state || {};
    const [show, setShow] = useState(false)
    const [vehicleData, setVehicleData] = useState([]);
    const [collapsedState, setCollapsedState] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const [dataState, setDataState] = useState(initialDataState);
    const [dataResult, setDataResult] = useState({ data: [], total: 0 });
    const [tableName, setTableName] = useState('')
    const [columnFields, SetColumnFields] = useState([])
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageSizeValue, setPageSizeValue] = useState();
    const [totalLength, setTotalLength] = useState(0)
    const excelExportRef = useRef(null);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const anchorRef = useRef(null);
    const popupRef = useRef(null);
    const csvLinkRef = useRef();
    const gridContainerRef = useRef(null);

    // const [selectedMonth, setSelectedMonth] = useState({ id: 10, name: 'Octobor' });
    // const [selectedYear, setSelectedYear] = useState({ id: 2024, name: "2024" });
    const [data, setData] = useState([]);
    let [userData, setUserData] = useState([])


    useEffect(() => {
        let fetchUserData = async () => {
            setLoading(true)
            let data = validateUserData()
            if (data) {
                if (data?.routes && data?.routes[0].route) {
                    if (data?.routes[0]?.route !== '/') {
                        let homeRoute = data?.routes[0]?.route || '/'
                        navigate(homeRoute)
                    }
                }
            }
            setUserData(data);
            setLoading(false)
        }
        fetchUserData()
    }, [])

    const accessibleRegions = userData?.AccessData?.map((item) => item?.region);
    //const accessibleRegions = userData?.RegionAccess ? userData?.RegionAccess.split(',') : [];
    const filteredRegions = regions?.filter((region) => {
        return accessibleRegions?.includes(region?.name)
    })
    const [selectedRegion, setSelectedRegion] = useState(filteredRegions[0] || null);

    const startingDate = new Date(userData?.vio_StartDate)
    const startingYear = startingDate?.getFullYear()
    const startingMonth = startingDate?.getMonth() + 1
    const currentYear = new Date().getFullYear()
    const [selectedMonth, setSelectedMonth] = useState(newMonth || {
        id: 10,
        name: 'October'
    });


    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const prevSelectedMonth = useRef(selectedMonth);

    const { i18n } = useTranslation();

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const [selectedYear, setSelectedYear] = useState(years[0] || {});


    useEffect(() => {
        if (!userData || !selectedRegion) return
        let yearsMap = userData?.AccessData?.filter((item) => item?.region === selectedRegion?.name).map((ele) => ele?.years?.map((item) => item?.year))
        let flatteredMap = [...new Set(yearsMap.flat())]
        const yearsArray = flatteredMap.map((i) => {
            return { id: i, name: i.toString() };
        }).sort((a, b) => b.id - a.id);
        setYears(yearsArray);
        setSelectedYear(yearsArray[0])
    }, [selectedRegion]);

    useEffect(() => {
        if (!userData) return;
        const getMonth = userData?.AccessData?.filter((item) => item?.region === selectedRegion?.name).map((ele) => ele?.years?.filter((item) => item?.year === selectedYear?.id)).flat()
        const monthsArray = getMonth?.length > 0 ? getMonth[0].months : []
        let monthsMap = monthsArray?.map((month) => {
            return {
                id: month,
                name: new Date(2021, month - 1).toLocaleString('default', { month: "long" })
            }
        }).reverse()
        setMonths(monthsMap);
        setSelectedMonth(monthsMap[0])
    }, [selectedYear, selectedRegion]);


    useEffect(() => {
        if (!userData) {
            navigate('/login');
            History.push("/login")
        }
    }, [userData, navigate]);



    useEffect(() => {
        if (filteredRegions.length > 0 && !selectedRegion) {
            setSelectedRegion(filteredRegions[0]);  // Set initial region
        }
    }, [filteredRegions]);



    const onExpandChange = useCallback(event => {
        const item = event.dataItem;
        if (item.groupId) {
            const collapsedIds = !event.value ? [...collapsedState, item.groupId] : collapsedState.filter(groupId => groupId !== item.groupId);
            setCollapsedState(collapsedIds);
        }
    }, [collapsedState]);

    const fetchDataForPagination = async (event, type) => {
        setFilterValue('')
        let skip = 0;
        let take = 100;
        let filters = {}
        let changePagination = false
        if (type === "PAGINATION") {
            skip = event?.page?.skip;
            take = event?.page?.take
            filters = dataState?.filter || { logic: "and", filters: [] }
        }
        else {
            skip = dataState?.skip;
            take = dataState?.take
            filters = event?.filter || { logic: "and", filters: [] }
            changePagination = true
        }
        const activeSort = dataState?.sort?.length > 0
            ? dataState.sort
            : dataState?.group?.length > 0
                ? dataState.group.map(g => ({
                    field: g.field,
                    dir: g.dir || 'asc'
                }))
                : []
        const body = {
            region: selectedRegion?.value,
            table_month: selectedMonth?.id,
            table_year: selectedYear?.id,
            pageSize: take,
            page: (skip / take) + 1,
            filters: filters,
            changePagination,
            sort: activeSort
        }
        // console.log("=== fetchDataForPagination ===")
        // console.log("dataState.group:", JSON.stringify(dataState.group))
        // console.log("dataState.sort:", JSON.stringify(dataState.sort))
        // console.log("activeSort:", JSON.stringify(activeSort))
        // console.log("body.sort:", JSON.stringify(body.sort))
        if (selectedRegion && accessibleRegions?.includes(selectedRegion.name) && selectedMonth && selectedYear) {
            prevSelectedMonth.current = selectedMonth;
            try {
                if (userData && !loading && selectedRegion) {
                    setIsButtonClicked(true)
                    setLoading(true);
                    if (selectedYear.id === startingYear && selectedMonth.id < startingMonth) {
                        setSelectedMonth({
                            id: startingMonth,
                            name: new Date(2021, startingMonth - 1).toLocaleString('default', { month: "long" })
                        });
                        setLoading(false)
                        return;
                    }
                    const CurrentLanguage = i18n.language
                    const apiResponse = await getDashboardDataByPagination({ userData, body, CurrentLanguage });

                    if ((apiResponse && apiResponse?.status === 401) || (apiResponse && apiResponse.error && apiResponse.error.statusCode === 401)) {
                        setLoading(false);
                        localStorage.removeItem("userData")
                        navigate('/login')
                        History.push('/login')
                        toast.error('Session Expired.')
                    }
                    else if (apiResponse && apiResponse?.data && apiResponse?.data.length > 0) {
                        setVehicleData(apiResponse.data);

                        setFilteredData(apiResponse.data);

                        setTotalLength(apiResponse.pagination.totalRecords);

                        setIsDataAvailable(apiResponse.data.length > 0);
                        // Update data state before processing
                        let newPage = ((apiResponse?.pagination?.currentPage - 1) * (apiResponse?.pagination?.pageSize || 100));
                        setDataState((prevState) => ({

                            ...prevState,

                            take: take,

                            skip: newPage,

                        }));

                        // Process the data with the updated state

                        const newDataResult = processWithGroups(apiResponse.data, {
                            ...dataState,
                            take: take || 100,
                            skip: 0
                        });
                        setDataResult(newDataResult);

                        // setDataState((prevState) => ({
                        //     ...prevState,
                        //     take: apiResponse?.pagination?.pageSize,
                        //     skip: (apiResponse?.pagination?.currentPage - 1) * prevState?.take, // Update skip based on current page

                        // }));
                        setLoading(false)
                    }
                    else {
                        toast("No Data Found", {
                            autoClose: true,
                            type: "error"
                        })
                        setVehicleData(apiResponse?.data || []);
                        setFilteredData(apiResponse?.data || []);
                        setIsDataAvailable(apiResponse.data.length > 0);
                        setDataResult({ data: [], total: 0 });
                        setLoading(false)
                    }
                }
            }
            catch (err) {
                const errorMessage = err.message;
                const errorStatus = err.status || null;
                if (errorStatus === 401 || err?.statusCode === 401) {
                    localStorage.removeItem('userData')
                    navigate('/login')
                    History.push("/login")
                    toast('Session Expired.', {
                        autoClose: true,
                        type: 'error'
                    })
                    return;
                }
                toast('No Data Found', {
                    autoClose: true,
                    type: 'error'
                })
                setError(err);
                setLoading(false);
            }
        }
    }


    const fetchData = async () => {
        setFilterValue('')
        const body = {
            region: selectedRegion?.value,
            table_month: selectedMonth?.id,
            table_year: selectedYear?.id,
            pageSize: dataState?.take,
            page: 1
        }
        if (selectedRegion && accessibleRegions?.includes(selectedRegion.name) && selectedMonth && selectedYear) {
            prevSelectedMonth.current = selectedMonth;
            try {
                if (userData && !loading && selectedRegion) {
                    setIsButtonClicked(true)
                    setLoading(true);
                    if (selectedYear.id === startingYear && selectedMonth.id < startingMonth) {
                        setSelectedMonth({
                            id: startingMonth,
                            name: new Date(2021, startingMonth - 1).toLocaleString('default', { month: "long" })
                        });
                        setLoading(false)
                        return;
                    }
                    const CurrentLanguage = i18n.language
                    const apiResponse = await getDashboardData({ userData, body, CurrentLanguage });

                    if ((apiResponse && apiResponse?.status === 401) || (apiResponse && apiResponse.error && apiResponse.error.statusCode === 401)) {
                        setLoading(false);
                        localStorage.removeItem("userData")
                        navigate('/login')
                        History.push('/login')
                        toast.error('Session Expired.')
                    }
                    else {
                        const fetchedData = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
                        if (fetchedData && fetchedData.length > 0) {
                            setVehicleData(apiResponse?.data || []);
                            setFilteredData(apiResponse?.data || []);
                            setTableName(apiResponse?.tableName)

                            setDataResult(processWithGroups(fetchedData, {
                                ...initialDataState,
                                take: dataState.take,
                                skip: 0
                            }));
                            setDataState((prevState) => ({
                                ...prevState,
                                filter: { filters: [], logic: "and" },
                                group: [],
                                sort: [],
                                skip: 0
                            }))
                            setIsDataAvailable(fetchedData.length > 0);
                            setTotalLength(apiResponse?.pagination?.totalRecords)
                            if (fetchedData && fetchedData.length > 0) {
                                const fields = Object.keys(fetchedData[0])
                                const orderKeys = Object.keys(mappingFields)
                                const columnMeta = await orderKeys.filter((key) => fields?.includes(key)).map((item) => ({
                                    field: item,
                                    title: mappingFields[item].value,
                                    width: mappingFields[item].width
                                }))
                                SetColumnFields(columnMeta)
                            }
                            else {
                                toast('No Data Found', {
                                    type: "error",
                                    autoClose: true,
                                })
                            }
                            setDataState(initialDataState)
                            setLoading(false);
                        }
                        else {
                            setLoading(false)
                            toast('No Data Found', {
                                type: "error",
                                autoClose: true,
                            })
                            SetColumnFields([])
                            setDataState(initialDataState)
                            setVehicleData(apiResponse?.data || []);
                            setFilteredData(apiResponse?.data || []);
                            setIsDataAvailable(apiResponse.data.length > 0);
                            setDataResult({ data: [], total: 0 });
                        }
                    }
                }
            } catch (err) {
                const errorMessage = err.message;
                const errorStatus = err.status || null;
                if (errorStatus === 401 || err?.statusCode === 401) {
                    localStorage.removeItem('userData')
                    navigate('/login')
                    History.push("/login")
                    toast('Session Expired.', {
                        autoClose: true,
                        type: 'error'
                    })
                    return;
                }
                SetColumnFields([])
                setVehicleData([]);
                setFilteredData([]);
                setIsDataAvailable(false);
                setDataResult({ data: [], total: 0 });
                toast('No Data Found', {
                    autoClose: true,
                    type: 'error'
                })
                setDataState(initialDataState)
                setError(err);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        // Function to handle language change

        const handleLanguageChange = () => {
            if (filteredData.length > 0) {
                // Refetch data when language changes
                fetchData();
            };
        }

        // Add event listener for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Clean up the event listener when component unmounts
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n, fetchData]);


    const handlePopperToggle = (event) => {
        setShow((prev) => !prev);
        anchorRef.current = event.currentTarget;
    };



    const onFilterChange = (ev) => {

        const value = ev ? ev.value : ''; // Get the input value and convert to lower case

        setFilterValue(value); // Set the filter value for the input field

        // Filter the vehicleData based on the input value
        const newData = vehicleData.filter((item) => {
            return Object.values(item).some((property) => {
                return property != null && property.toString().toLowerCase().includes(value.toLowerCase());
            });
        });

        // Update the filteredData and apply the data processing (paging, sorting)
        setFilteredData(newData); // Update filtered data
        setDataResult(process(newData, { ...dataState, skip: 0 })); // Apply filtering to data
        setData(newData); // Update data with filtered data
    };

    const dataStateChange = useCallback(async (event) => {

        const newDataState = event.dataState;
        const hasGroups = newDataState.group && newDataState.group.length > 0;
        const hadGroups = dataState.group && dataState.group.length > 0;

        const sortChanged = JSON.stringify(newDataState.sort) !== JSON.stringify(dataState.sort)

        if (hasGroups || (sortChanged && dataState.group?.length > 0)
        ) {

            const finalSort = newDataState.group?.length > 0
                ? newDataState.group.map(g => ({
                    field: g.field,
                    dir: g.dir || 'asc'
                }))
                : []
            const body = {
                region: selectedRegion?.value,
                table_month: selectedMonth?.id,
                table_year: selectedYear?.id,
                pageSize: dataState.take,
                page: 1,
                filters: dataState.filter,
                changePagination: false,
                sort: finalSort   
            }

            // console.log("=== dataStateChange ===")
            // console.log("=== dataStateChange ===")
            // console.log("newDataState.group:", JSON.stringify(newDataState.group))
            // console.log("newDataState.sort:", JSON.stringify(newDataState.sort))
            // console.log("finalSort being sent to backend:", JSON.stringify(finalSort))
            setLoading(true)
            const CurrentLanguage = i18n.language
            const apiResponse = await getDashboardDataByPagination({ userData, body, CurrentLanguage })
            if (apiResponse?.data?.length > 0) {
                setVehicleData(apiResponse.data)
                setFilteredData(apiResponse.data)
                setTotalLength(apiResponse.pagination.totalRecords)
                setIsDataAvailable(true)
                const newDataResult = processWithGroups(apiResponse.data, {
                    ...newDataState,
                    skip: 0,
                    take: dataState.take
                })
                setDataState({
                    ...newDataState,
                    skip: 0,
                    take: dataState.take
                })
                setDataResult(newDataResult)
            }
            setLoading(false)
        }
        else {
            const newDataResult = processWithGroups(filteredData, newDataState)
            setDataState({
                ...newDataState,
                skip: dataState.skip
            })
            setDataResult(newDataResult)
        }
    }, [filteredData, dataState, selectedRegion, selectedMonth, selectedYear, i18n, userData])



    const itemRender = (li, itemProps) => {
        const item = itemProps.dataItem;
        return (

            <li {...li.props} className="region-item" style={{ cursor: "pointer" }}>
                <img src={item.flag} alt={item.name} style={{ width: '20px', marginRight: '10px' }} />
                {item.name}
            </li>

        );
    };

    const valueRender = (li, itemProps) => {
        if (!itemProps) return null;
        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "start", width: "100%" }}>
                <img src={itemProps.flag} alt={itemProps.name} style={{ width: '20px', margin: '0 10px' }} />
                {itemProps.name}
            </div>
        )
    }


    useEffect(() => {
        const handleClickOutSide = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target) && !anchorRef.current.contains(event.target)) {
                setShow(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutSide)
        return () => {
            document.removeEventListener("mousedown", handleClickOutSide)
        }
    }, [])



    const exportExcel = async () => {
        setLoading(true)
        const dataStateForExport = {
            ...dataState,
            skip: 0,
            take: Number.MAX_SAFE_INTEGER,
        };
        const body = {
            region: selectedRegion?.value,
            table_month: selectedMonth?.id,
            table_year: selectedYear?.id,
            isExcelExport: true,
            isVIOExport: true,
            filters: dataState?.filter
        }
        const getExcelExportResponse = await exportData({ userData, body })
        if (getExcelExportResponse?.status === 401 || getExcelExportResponse?.error?.statusCode === 401) {
            localStorage.removeItem("userData")
            navigate('/login')
            toast.error('Session Expired.')
            setLoading(false)
            return;
        }
        else if (getExcelExportResponse?.status !== 200) {
            toast(getExcelExportResponse?.message, {
                type: "info",
                autoClose: true
            })
            setLoading(false)
            return;
        }
        let processedData = getExcelExportResponse?.data || []
        if (dataStateForExport?.filter?.filters.length > 0) {
            processedData = applyFilter(processedData, dataStateForExport?.filter.filters, dataStateForExport?.filter.filters.logic)
        }

        if (dataStateForExport.group.length > 0) {
            const filteredAndGroupedData = process(processedData, dataStateForExport);
            processedData = dataState.group && dataState.group.length > 0 ? flatternGroup(filteredAndGroupedData.data) : processedData
        }
        if (dataStateForExport?.sort?.length > 0) {
            processedData = applySort(processedData, dataStateForExport.sort);
        }

        if (processedData.length === 0) {
            toast("No data available for export", { type: "warning", autoClose: true });
            setLoading(false);
            return;
        }



        if (excelExportRef.current) {
            try {
                // Trigger the export
                const options = {
                    data: processedData,
                    fileName: `${selectedRegion.name}_${selectedMonth.name}_${selectedYear.name}.csv`,
                    creator: 'Vioservice',
                    title: 'Vehicle Data Export',
                    filterable: true,
                };
                await excelExportRef.current.save(options);
                // Ensure loading state is cleared after the export is triggered

            } catch (error) {
                toast("Failed to export data to Excel.", { type: "error", autoClose: true });
            }
        };
    }


    const fetchDataForCSV = async () => {
        setLoading(true)
        const body = {
            region: selectedRegion?.value,
            table_month: selectedMonth?.id,
            table_year: selectedYear?.id,
            isCSVExport: true,
            isVIOExport: true,
            filters: dataState?.filter
        }
        try {
            const getExcelExportResponse = await exportData({ userData, body })
            if (getExcelExportResponse?.status === 401 || getExcelExportResponse?.error?.statusCode === 401) {
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
                setLoading(false)
                return { success: false, data: [] };
            }
            else if (getExcelExportResponse?.status !== 200) {
                toast(getExcelExportResponse?.message, {
                    type: "info",
                    autoClose: true
                })
                setLoading(false)
                return { success: false, data: [] };
            }
            else if (getExcelExportResponse?.status === 200) {
                toast(getExcelExportResponse?.message, {
                    type: "success",
                    autoClose: true
                })
                setLoading(false)
                return { success: true, data: getExcelExportResponse?.data };
            }
            else {
                toast.error('Failed to fetch data for CSV export.');
                setLoading(false)
                return { success: false, data: [] };
            }
        } catch (error) {
            setLoading(false)
            console.error('Error fetching data for CSV:', error);
            toast.error('Error fetching data for CSV export.');
            return { success: false, data: [] };
        }
    };

    const handleExportCsv = async () => {
        try {
            setLoading(true)
            const headers = Object.keys(mappingFields).map((key) => ({
                label: mappingFields[key].value,
                key: key,
            }));


            const dataStateForExport = {
                ...dataState,
                skip: 0,
                take: Number.MAX_SAFE_INTEGER,
            };
            const data = await fetchDataForCSV();
            if (data.success === false) {
                setLoading(false)
                return;
            }
            let processedData = data.data || []
            if (dataStateForExport?.filter?.filters.length > 0) {
                processedData = applyFilter(processedData, dataStateForExport?.filter.filters, dataStateForExport?.filter.filters.logic)
            }

            if (dataStateForExport.group.length > 0) {
                const filteredAndGroupedData = process(processedData, dataStateForExport);
                processedData = dataState.group && dataState.group.length > 0 ? flatternGroup(filteredAndGroupedData.data) : processedData
            }
            if (dataStateForExport?.sort?.length > 0) {
                processedData = applySort(processedData, dataStateForExport.sort);
            }

            if (processedData.length === 0) {
                toast("No data available for export", { type: "warning", autoClose: true });
                setLoading(false);
                return;
            }


            const csvData = processedData.map(item => {
                return Object.keys(mappingFields).reduce((acc, key) => {
                    let value = item[key] != null ? item[key].toString() : '';
                    // Escape double quotes inside the data by replacing " with ""
                    value = value.replace(/"/g, '""');
                    // Enclose values in double quotes (only for strings and non-numeric values)
                    acc[key] = value ? `"${value}"` : ''; // Add quotes to non-empty values
                    return acc;
                }, {});
            });

            // Generate CSV string with quotes around header labels and data rows
            const csvString = [
                // Header row with quotes around the label
                headers.map(header => `"${header.label.replace(/"/g, '""')}"`).join(','),
                // Data rows
                ...csvData.map(row => headers.map(header => row[header.key] || '').join(','))
            ].join('\n');

            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${selectedRegion?.name}_${selectedMonth?.name}_${selectedYear?.name}.csv`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);
        } catch (error) {
            setLoading(false)
            console.error('Error exporting CSV:', error);
        }
    };

    const exportComplete = () => {
        setLoading(false)
        toast("Excel Exported Successfully", { type: "success", autoClose: true });
    }

    const dataWithExpandedState = setExpandedState({
        data: dataResult.data || [],
        collapsedIds: collapsedState
    });

    const onPageChange = (event) => {
        // Scroll to the top of the grid with ref
        const gridContent = gridContainerRef.current?.querySelector('.k-grid-content')
        if (gridContent) {
            gridContent.scrollTo({ top: 0, behavior: 'smooth' })
        }
        setDataState((prevState) => ({

            ...prevState,

            take: event?.page?.take || 100,
            skip: event?.page?.skip || 0,
        }));
        const type = "PAGINATION"
        fetchDataForPagination(event, type)
    }

    const onFilterChangeForAll = (event) => {
        const newFilter = event?.filter ? event.filter : { logic: "and", filters: [] };
        const currentSkip = dataState?.skip || 0
        const currentTake = dataState?.take || 100
        setDataState((prevState) => ({
            ...prevState,
            filter: event?.filter,
            take: currentTake,
            skip: currentSkip
        }));
        const type = "FILTERATION"
        fetchDataForPagination(event, type)
    }

    return (
        <div ref={gridContainerRef} style={{ position: 'relative', height: '100%' }}>
            <LoaderOverlay loading={loading} />
            <ExcelExport data={vehicleData} ref={excelExportRef} fileName={`${selectedRegion?.name}_${selectedMonth?.name}_${selectedYear?.name}.xlsx`} onExportComplete={exportComplete}>
                <Grid
                    // style={{ height: '100%' }}
                    pageable={isDataAvailable ? {
                        buttonCount: 4,
                        pageSizes: [100, 200, 500, 1000],
                        pageSizeValue: pageSizeValue,
                    } : false}
                    data={dataWithExpandedState}
                    skip={dataState?.skip}
                    take={dataState?.take}
                    total={totalLength}
                    group={dataState?.group}
                    sortable={isDataAvailable}
                    onExpandChange={onExpandChange}
                    onPageChange={onPageChange}
                    onFilterChange={onFilterChangeForAll}
                    groupable={isDataAvailable}
                    expandField="expanded"
                    style={{
                        height: '100%',
                        transition: 'opacity 0.2s ease-in-out',
                    }}
                    onDataStateChange={dataStateChange}
                    {...dataState}
                    dataItemKey={DATA_ITEM_KEY}
                >
                    <GridToolbar>
                        <div className='header-div'>
                            <div className='input-filter'>
                                <Input
                                    value={filterValue}
                                    disabled={!isDataAvailable}
                                    onChange={ev => onFilterChange(ev)}
                                    style={{ border: '2px solid #ccc', width: '210px', height: '30px', marginRight: '10px' }}
                                    placeholder="Search in all columns..."
                                />
                                <DropDownList
                                    data={filteredRegions}
                                    textField="name"
                                    dataItemKey="id"
                                    itemRender={itemRender}
                                    valueRender={valueRender}
                                    value={selectedRegion}
                                    onChange={e => setSelectedRegion(e.target.value)}
                                    style={{ width: '150px', marginRight: '10px' }}
                                />
                                <DropDownList
                                    data={years}
                                    textField="name"
                                    dataItemKey="id"
                                    value={selectedYear}
                                    onChange={e => setSelectedYear(e.target.value)}
                                    optionLabel="Select Year"
                                    style={{ width: '150px', marginRight: '10px' }}
                                />
                                <DropDownList
                                    data={months}
                                    textField="name"
                                    dataItemKey="id"
                                    value={selectedMonth}
                                    onChange={e => setSelectedMonth(e.target.value)}
                                    optionLabel="Select Month"
                                    style={{ width: '150px', marginRight: '10px' }}
                                />
                                <Button style={{ color: "white", backgroundColor: "#1976d2" }} onClick={fetchData}>Search</Button>
                            </div>
                            <div className="export-btns-container" style={{ position: 'relative' }}>
                                <TooltipMUI title={isDataAvailable ? "Download" : "No data available"}>
                                    <span>
                                        <TriggerButton
                                            style={{
                                                backgroundColor: 'transparent',
                                                cursor: isDataAvailable ? "pointer" : "not-allowed",
                                                border: 'none',
                                                color: isDataAvailable ? "rgb(65, 65, 65)" : "rgb(189, 189, 189)"
                                            }} isDataAvailable={isDataAvailable} aria-describedby={id} type="button" onClick={handlePopperToggle} disabled={!isDataAvailable}>
                                            <FontAwesomeIcon icon={faDownload} size="xl" />
                                        </TriggerButton>
                                    </span>
                                </TooltipMUI>
                                <Popper open={show} anchorEl={anchorRef.current} ref={popupRef} sx={{ top: "0px !important", left: "-10px !important", zIndex: 100000 }} onClose={() => setShow(false)}>
                                    <StyledPopperDiv>
                                        <Button onClick={handleExportCsv}
                                            style={{ margin: '5px 0px' }} className="forFileExcel">
                                            <FontAwesomeIcon icon={faFileCsv} />
                                        </Button>
                                        <Button onClick={exportExcel} style={{ margin: '5px 0px' }} className="forFileExcel">
                                            <FontAwesomeIcon icon={faFileExcel} />
                                        </Button>
                                    </StyledPopperDiv>
                                </Popper>
                            </div>
                        </div >
                    </GridToolbar >
                    <GridNoRecords>
                        {!isDataAvailable && !loading && isButtonClicked && (
                            <div className="no-data-found">
                                <div className="no-data-icon">
                                    <FontAwesomeIcon icon={faCircleExclamation} size="7x" />
                                </div>
                                <div className="no-data-message">
                                    No Data Available
                                </div>
                            </div>
                        )}
                        <></>
                    </GridNoRecords>
                    {
                        columnFields?.length > 0 && (
                            columnFields?.map((col, index) => (
                                <Column
                                    key={index}
                                    field={col.field}
                                    title={col.title}
                                    width={col.width}
                                    columnMenu={ColumnMenu}
                                />
                            ))
                        )
                    }
                </Grid >
            </ExcelExport >



        </div >
    );
}

const ColumnMenu = (props) => {
    return (
        <div>
            <GridColumnMenuSort {...props} />
            <GridColumnMenuFilter {...props} />
            <GridColumnMenuGroup {...props} />
        </div>
    );
};
const TriggerButton = styled('button')(
    ({ theme, isDataAvailable }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 5px 5px;
  background-color: transparent;
  border-radius: 8px;
  color: grey[500];
  transition: all 150ms ease;
  cursor: pointer;
  border: none;
  box-shadow: none;

  &:focus-visible {
    box-shadow: 0 0 0 4px ${theme.palette.mode === 'dark' ? grey[300] : grey[200]};
    outline: none;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;

    &:hover {
      background-color: ${grey[500]};
    }
  }
`
);

const StyledPopperDiv = styled('div')(
    ({ theme }) => css`
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: ${theme.palette.mode === 'dark'
            ? `0px 4px 8px rgb(0 0 0 / 0.7)`
            : `0px 4px 8px rgb(0 0 0 / 0.1)`};
    padding: 10px;
    color: ${theme.palette.mode === 'dark' ? grey[100] : grey[700]};
    font-size: 0.875rem;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    opacity: 1;
    margin: 0.25rem 0;
  `
);




export default HomePage